// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__TtBE-","title":"AfterBackImages_title__Tmcez","images":"AfterBackImages_images__LKI1w"};